export default [
  {
    path: '/meus',
    name: 'meus',
    component: () => import(/* webpackChunkName: "meus" */ './Meus.vue')
  }
]
